import * as Utils from 'Assets/Utils'

import ClientHttpRequest from "Api/ClientHttpRequest"
import { Map, List } from 'immutable'
import { createModal } from 'Modules/Modal'
import { isLoading } from 'Modules/Loading'

const initialState = Map({}).set('Get', new List([]))

/* Types */
export const TYPE = 'TYPE'

/* Reducer */
export default (state = initialState, action) => {

	switch (action.type) {
		case TYPE:
			return state.set('Get',new List(action.Obj))
		default:
			return state;
	}
};

/* Action Creators */

export const saveDocumentsAndLegalReps = (form) => {

	let documentos = form.documentos.map((d) => {
		return {
			idDocumento: d.tipo.id,
			idFase: d.fase.id,
			revisado: d.revisado || false
		}
	})

	let representanteLegal = form.representanteLegal.map((r) => {
		return {
			idRepresentanteLegal: r.idRepresetanteLegal,
			revisado: r.revisado || false
		}
	})

	let temp = {
		usuario: sessionStorage.uid,
		documentosRegistro: documentos,
		idDonataria: form.idDonataria,
		representantesLegales: representanteLegal
	}
	
	return (dispatch) => {

		dispatch(isLoading(true));

		return new ClientHttpRequest({
			service: 'api/saveDocumentsAndLegalReps',
			method: "POST",
			data: {...temp},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))
			return response.data
		}).catch(error => {
			dispatch(isLoading(false));
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error;
		});
	}
}



// WEBPACK FOOTER //
// ./src/modules/MissingInfo/DocumentsAndLegalReps/index.js